import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Box, 
  Typography, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem 
} from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

const CourseEnrollmentDialog = ({ 
  open, 
  onClose, 
  selectedCourse, 
  enrollForm, 
  onFormChange, 
  monthOptions, 
  onSubmit, 
  calculatePaymentAmount 
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Iscriviti al Corso</DialogTitle>
      <DialogContent>
        {selectedCourse && (
          <Box sx={{ mb: 3 }}>
            <Typography variant='h6' gutterBottom>
              {selectedCourse.name}
            </Typography>
            <Typography variant='body2' color='text.secondary' gutterBottom>
              {selectedCourse.description}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              Sede: {selectedCourse.venue}
            </Typography>
            {selectedCourse.weekdays && selectedCourse.weekdays.length > 0 && (
              <Typography variant='body2' color='text.secondary'>
                Giorni: {selectedCourse.weekdays.map(day => {
                  const dayMap = {
                    0: 'Dom',
                    1: 'Lun',
                    2: 'Mar',
                    3: 'Mer',
                    4: 'Gio',
                    5: 'Ven',
                    6: 'Sab'
                  };
                  return dayMap[day] || day;
                }).join(', ')}
              </Typography>
            )}
            {selectedCourse.time && (
              <Typography variant='body2' color='text.secondary'>
                Orario: {selectedCourse.time}
              </Typography>
            )}
            {selectedCourse.minLevel !== undefined && selectedCourse.minLevel !== null && (
              <Typography variant='body2' color='text.secondary'>
                Anno di corso: {selectedCourse.minLevel >= 6 ? 'Oltre il 5° anno' : `${selectedCourse.minLevel}° anno`}
              </Typography>
            )}
            {selectedCourse.startDate && (
              <Typography variant='body2' color='text.secondary'>
                Inizio: {dayjs(selectedCourse.startDate).locale('it').format('DD MMM YY')}
              </Typography>
            )}
            {selectedCourse.endDate && (
              <Typography variant='body2' color='text.secondary'>
                Fine: {dayjs(selectedCourse.endDate).locale('it').format('DD MMM YY')}
              </Typography>
            )}
          </Box>
        )}

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Metodo di Pagamento</InputLabel>
          <Select
            value={enrollForm.paymentMethod}
            label='Metodo di Pagamento'
            onChange={(e) =>
              onFormChange((prev) => ({
                ...prev,
                paymentMethod: e.target.value,
              }))
            }
          >
            {selectedCourse?.pricing?.monthly > 0 && (
              <MenuItem value='monthly'>Mensile (€{selectedCourse?.pricing?.monthly})</MenuItem>
            )}
            {selectedCourse?.pricing?.annual3 > 0 && (
              <MenuItem value='annual3'>Annuale (3 rate di €{selectedCourse?.pricing?.annual3})</MenuItem>
            )}
            {selectedCourse?.pricing?.annual1 > 0 && (
              <MenuItem value='annual1'>Annuale (1 rata di €{selectedCourse?.pricing?.annual1})</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Iscrizione valida a partire dal mese di</InputLabel>
          <Select
            value={enrollForm.startDate}
            label='Iscrizione valida a partire dal mese di'
            onChange={(e) =>
              onFormChange((prev) => ({
                ...prev,
                startDate: e.target.value,
              }))
            }
            required
          >
            {monthOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          sx={{
            p: 2,
            bgcolor: 'grey.100',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant='body1' fontWeight='bold'>
            Importo Totale:
          </Typography>
          <Typography variant='h6' color='primary' fontWeight='bold'>
            €{calculatePaymentAmount(enrollForm.paymentMethod)}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button 
          onClick={onSubmit} 
          variant='contained'
          disabled={!enrollForm.startDate}
        >
          Conferma Iscrizione
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CourseEnrollmentDialog;
